import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';
import { Form } from 'antd';

const DuplicateContentProvider = (props) => {
  const api = new API();
  const [duConPopup, setDuConPopup] = useState(false);
  const [duConForm1] = Form.useForm();
  const [duPearlsLoader, setDuPearlsLoader] = useState(false);
  const [duUpdatesLoader, setDuUpdatesLoader] = useState(false);
  const [duDNBMDLoader, setDuDNBMDLoader] = useState(false);
  const [duQbankLoader, setDuQbankLoader] = useState(false);
  const [duTestSeriesLoader, setDuTestSeriesLoader] = useState(false);
  const [duVideosLoader, setDuVideosLoader] = useState(false);
  const duConPearls = async (data,setBulkActionVideoExam) => {
    const rxdx_admin_login = localStorage.getItem("rxdx_admin_login");
    if(!rxdx_admin_login) return;
    setDuPearlsLoader(true);
    await api.create("duplicate/pearlsduplicate", data, (err, res) => {
      if (res?.data?.status === 200) {
        setBulkActionVideoExam && setBulkActionVideoExam([]);
        Widget.showMessage("success", res?.data?.message);
        duConForm1.resetFields();
        setDuConPopup(false);
      } else {
        Widget.showMessage("error", res?.data?.message);
      }
      setDuPearlsLoader(false);
    });
  }
  const duConUpdates = async (data,setBulkActionVideoExam) => {
    const rxdx_admin_login = localStorage.getItem("rxdx_admin_login");
    if(!rxdx_admin_login) return;
    setDuUpdatesLoader(true);
    await api.create("duplicate/updatesduplicate", data, (err, res) => {
      if (res?.data?.status === 200) {
        setBulkActionVideoExam && setBulkActionVideoExam([]);
        Widget.showMessage("success", res?.data?.message);
        duConForm1.resetFields();
        setDuConPopup(false);
      } else {
        Widget.showMessage("error", res?.data?.message);
      }
      setDuUpdatesLoader(false);
    });
  }
  const duConDNBMD = async (data,setBulkActionVideoExam) => {
    const rxdx_admin_login = localStorage.getItem("rxdx_admin_login");
    if(!rxdx_admin_login) return;
    setDuDNBMDLoader(true);
    await api.create("duplicate/dnbmdduplicate", data, (err, res) => {
      if (res?.data?.status === 200) {
        setBulkActionVideoExam && setBulkActionVideoExam([]);
        Widget.showMessage("success", res?.data?.message);
        duConForm1.resetFields();
        setDuConPopup(false);
      } else {
        Widget.showMessage("error", res?.data?.message);
      }
      setDuDNBMDLoader(false);
    });
  }
  const duConVideos = async (data,setBulkActionVideoExam) => {
    const rxdx_admin_login = localStorage.getItem("rxdx_admin_login");
    if(!rxdx_admin_login) return;
    setDuVideosLoader(true);
    await api.create("duplicate/videoduplicate", data, (err, res) => {
      if (res?.data?.status === 200) {
        setBulkActionVideoExam && setBulkActionVideoExam([]);
        Widget.showMessage("success", res?.data?.message);
        duConForm1.resetFields();
        setDuConPopup(false);
      } else {
        Widget.showMessage("error", res?.data?.message);
      }
      setDuVideosLoader(false);
    });
  }
  const duConQbank = async (data,setBulkActionVideoExam) => {
    const rxdx_admin_login = localStorage.getItem("rxdx_admin_login");
    if(!rxdx_admin_login) return;
    setDuQbankLoader(true);
    await api.create("duplicate/qbankduplicate", data, (err, res) => {
      if (res?.data?.status === 200) {
        setBulkActionVideoExam && setBulkActionVideoExam([]);
        Widget.showMessage("success", res?.data?.message);
        duConForm1.resetFields();
        setDuConPopup(false);
      } else {
        Widget.showMessage("error", res?.data?.message);
      }
      setDuQbankLoader(false);
    });
  }
  const duConTestSeries = async (data,setBulkActionVideoExam) => {
    const rxdx_admin_login = localStorage.getItem("rxdx_admin_login");
    if(!rxdx_admin_login) return;
    setDuTestSeriesLoader(true);
    await api.create("duplicate/testseriesduplicate", data, (err, res) => {
      if (res?.data?.status === 200) {
        setBulkActionVideoExam && setBulkActionVideoExam([]);
        Widget.showMessage("success", res?.data?.message);
        duConForm1.resetFields();
        setDuConPopup(false);
      } else {
        Widget.showMessage("error", res?.data?.message);
      }
      setDuTestSeriesLoader(false);
    });
  }
  return (
    <Context.Provider value={{
      ...props,
      duConForm1,
      duConPopup, setDuConPopup,
      duPearlsLoader, setDuPearlsLoader,
      duUpdatesLoader, setDuUpdatesLoader,
      duDNBMDLoader, setDuDNBMDLoader,
      duQbankLoader, setDuQbankLoader,
      duTestSeriesLoader, setDuTestSeriesLoader,
      duVideosLoader, setDuVideosLoader,
      duConPearls,
      duConUpdates,
      duConDNBMD,
      duConVideos,
      duConQbank,
      duConTestSeries,
    }}>
      {props.children}
    </Context.Provider>
  )
};

export default DuplicateContentProvider;

